import React from 'react';
import {
  usePlateEditorRef,
} from '@udecode/plate';

import APModal from 'components/Modal/APModal';

const ErrorModal = () => {
  const editor = usePlateEditorRef();
  const errors = useError(editor);
  const error = errors.length > 0 ? errors[0] : null;
  const { message } = error || {};

  const dismiss = () => {
    editor.errorHandler?.popErrorMessage();
  };

  if (!error || error.length === 0) return null;

  return (
    <APModal
      open
      onClose={dismiss}
      width={620}
      height={300}
      size="narrow"
      title="Something went wrong."
      actions={(
        <>
          <button
            className="button"
            onClick={dismiss}
          >
            Ok
          </button>
        </>
      )}
    >
      {message}
    </APModal>
  );
};

const useError = (editor) => {
  const errors = editor.errorHandler.errorStore.use.errors();
  return errors || null;
};

export default ErrorModal;
